import React, { useState } from 'react';
import { MailIcon, PhoneIcon, MapPinIcon, ClockIcon, SendIcon, MessageSquareIcon } from 'lucide-react';
import { Input } from '../components/ui/Input';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { useScreenInit } from '../useScreenInit.js';
export function ContactPage() {
  const screenInit = useScreenInit() as {
    contactSubmitted?: boolean;
  };
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(!!screenInit.contactSubmitted);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    await new Promise(resolve => setTimeout(resolve, 1500));
    setIsSubmitting(false);
    setIsSubmitted(true);
  };
  return <div className="min-h-screen bg-gray-50" data-id="element-1272" data-mp="1qcq76s1cmqs0">
      {/* Hero */}
      <div className="bg-primary-600 py-16" data-id="element-1273" data-mp="r16roldp7hoq">
        <div className="max-w-7xl mx-auto px-4 text-center" data-id="element-1274" data-mp="qzvnwlk969xm">
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-1275" data-mp="mytl5ur4nfqw">
            Contact Us
          </h1>
          <p className="text-primary-100 max-w-2xl mx-auto" data-id="element-1276" data-mp="hyxjw39te2f1">
            Have questions? We'd love to hear from you. Send us a message and
            we'll respond as soon as possible.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-12" data-id="element-1277" data-mp="833v9litmigw">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-1278" data-mp="3akigqryjrd5">
          {/* Contact info */}
          <div className="space-y-6" data-id="element-1279" data-mp="3vedd8qg2as4d">
            <Card padding="lg" data-id="element-1280" data-mp="3vfelyo9lv2ix">
              <div className="flex items-start gap-4" data-id="element-1281" data-mp="3vcisbc4sj00a">
                <div className="w-12 h-12 bg-primary-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-1282" data-mp="3qh3bqcfeeq06">
                  <MailIcon className="w-6 h-6 text-primary-600" data-id="element-1283" data-mp="3lfxh2926gso0" />
                </div>
                <div data-id="element-1284" data-mp="3gi5rhlp09imz">
                  <h3 className="font-semibold text-gray-900" data-id="element-1285" data-mp="3gjp6za2u7pnp">Email Us</h3>
                  <p className="text-gray-600 text-sm mt-1" data-id="element-1286" data-mp="36sfd5cwfw22n">
                    We'll respond within 24 hours
                  </p>
                  <a href="mailto:waqas.nizam@paysyslabs.com" className="text-primary-600 hover:text-primary-700 font-medium mt-2 block" data-id="element-1287" data-mp="3bqqojs2dukmz">
                    waqas.nizam@paysyslabs.com
                  </a>
                </div>
              </div>
            </Card>

            <Card padding="lg" data-id="element-1288" data-mp="3pl1egcq48kum">
              <div className="flex items-start gap-4" data-id="element-1289" data-mp="3ujl2qjs6m8q5">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-1290" data-mp="3ui9pltcujomd">
                  <PhoneIcon className="w-6 h-6 text-green-600" data-id="element-1291" data-mp="3grxvjowpbfsl" />
                </div>
                <div data-id="element-1292" data-mp="3ks8c1vi4dolp">
                  <h3 className="font-semibold text-gray-900" data-id="element-1293" data-mp="3krouifwdt287">Call Us</h3>
                  <p className="text-gray-600 text-sm mt-1" data-id="element-1294" data-mp="cceurefys93l">
                    Mon-Sat from 9am to 9pm
                  </p>
                  <a href="tel:+923132370605" className="text-primary-600 hover:text-primary-700 font-medium mt-2 block" data-id="element-1295" data-mp="h6j23yt56j57">
                    +92-313-2370605
                  </a>
                </div>
              </div>
            </Card>

            <Card padding="lg" data-id="element-1296" data-mp="2bl6cmimpmayh">
              <div className="flex items-start gap-4" data-id="element-1297" data-mp="2bkdf889n4xt0">
                <div className="w-12 h-12 bg-primary-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-1298" data-mp="26la88ia3ohie">
                  <MapPinIcon className="w-6 h-6 text-primary-600" data-id="element-1299" data-mp="1ixainloiyx5e" />
                </div>
                <div data-id="element-1300" data-mp="1dxxy57l4m25z">
                  <h3 className="font-semibold text-gray-900" data-id="element-1301" data-mp="1dyfyogetn2jp">Visit Us</h3>
                  <p className="text-gray-600 text-sm mt-1" data-id="element-1302" data-mp="1suox5fqw1bv2">
                    Gadgets Zone
                    <br data-id="element-1303" data-mp="1nv2lhaqpk3od" />
                    Karachi, Pakistan
                  </p>
                </div>
              </div>
            </Card>

            <Card padding="lg" data-id="element-1304" data-mp="347r4rlb0er33">
              <div className="flex items-start gap-4" data-id="element-1305" data-mp="2zahek3fsqbe7">
                <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-1306" data-mp="2z9z9qif2iouo">
                  <ClockIcon className="w-6 h-6 text-purple-600" data-id="element-1307" data-mp="18vgmcy7xd26i" />
                </div>
                <div data-id="element-1308" data-mp="1dsqgusa68417">
                  <h3 className="font-semibold text-gray-900" data-id="element-1309" data-mp="1duba8ekr1gxh">
                    Business Hours
                  </h3>
                  <div className="text-gray-600 text-sm mt-2 space-y-1" data-id="element-1310" data-mp="1mtobijypyz74">
                    <p data-id="element-1311" data-mp="1mqsfx2acgmlu">Monday - Saturday: 9:00 AM - 9:00 PM</p>
                    <p data-id="element-1312" data-mp="1rrq6o39f6oyy">Sunday: 11:00 AM - 7:00 PM</p>
                  </div>
                </div>
              </div>
            </Card>
          </div>

          {/* Contact form */}
          <div className="lg:col-span-2" data-id="element-1313" data-mp="21j3zjs6v8qj4">
            <Card padding="lg" data-id="element-1314" data-mp="21k5matx8v1go">
              <div className="flex items-center gap-3 mb-6" data-id="element-1315" data-mp="25k61whw2xipb">
                <div className="w-10 h-10 bg-primary-100 rounded-full flex items-center justify-center" data-id="element-1316" data-mp="25lqvo5akkxm4">
                  <MessageSquareIcon className="w-5 h-5 text-primary-600" data-id="element-1317" data-mp="2agwgt1w5e895" />
                </div>
                <div data-id="element-1318" data-mp="2ffpsqpvsdr77">
                  <h2 className="text-xl font-semibold text-gray-900" data-id="element-1319" data-mp="2plheppq6os5a">
                    Send us a Message
                  </h2>
                  <p className="text-sm text-gray-500" data-id="element-1320" data-mp="2klmlvgmulshl">
                    Fill out the form below and we'll get back to you
                  </p>
                </div>
              </div>

              {isSubmitted ? <div className="text-center py-12" data-id="element-1321" data-mp="2bnazxrwxfivh">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-1322" data-mp="38c8tx7wurcrl">
                    <SendIcon className="w-8 h-8 text-green-600" data-id="element-1323" data-mp="33cnl85rvrq1o" />
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-1324" data-mp="2ym78knvvw8gd">
                    Message Sent!
                  </h3>
                  <p className="text-gray-600" data-id="element-1325" data-mp="2ujsl1qh9skir">
                    Thank you for contacting us. We'll get back to you within 24
                    hours.
                  </p>
                  <Button variant="outline" className="mt-6" onClick={() => {
                setIsSubmitted(false);
                setFormData({
                  name: '',
                  email: '',
                  phone: '',
                  subject: '',
                  message: ''
                });
              }} data-id="element-1326" data-mp="3mbi2bleth2l0">
                    Send Another Message
                  </Button>
                </div> : <form onSubmit={handleSubmit} className="space-y-4" data-id="element-1327" data-mp="1fmzh61a82ddy">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1328" data-mp="11nzugz69s8kf">
                    <Input label="Full Name" placeholder="Your name" value={formData.name} onChange={e => setFormData({
                  ...formData,
                  name: e.target.value
                })} required data-id="element-1329" data-mp="11q2t27lhna0r" />
                    <Input label="Email Address" type="email" placeholder="your@email.com" value={formData.email} onChange={e => setFormData({
                  ...formData,
                  email: e.target.value
                })} required data-id="element-1330" data-mp="wox0c9rtvmr8" />
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1331" data-mp="2r24xi83a0ag1">
                    <Input label="Phone Number" type="tel" placeholder="+92-XXX-XXXXXXX" value={formData.phone} onChange={e => setFormData({
                  ...formData,
                  phone: e.target.value
                })} data-id="element-1332" data-mp="fgcjszfzwtgx" />
                    <Input label="Subject" placeholder="How can we help?" value={formData.subject} onChange={e => setFormData({
                  ...formData,
                  subject: e.target.value
                })} required data-id="element-1333" data-mp="p7gyrz5o8ebr" />
                  </div>

                  <div data-id="element-1334" data-mp="u3fhb64bj249">
                    <label className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-1335" data-mp="u3xouywfl2rh">
                      Message
                    </label>
                    <textarea rows={6} placeholder="Tell us more about your inquiry..." value={formData.message} onChange={e => setFormData({
                  ...formData,
                  message: e.target.value
                })} className="w-full px-4 py-2.5 rounded-lg border border-gray-300 focus:border-primary-500 focus:ring-2 focus:ring-primary-200 transition-all duration-200 resize-none" required data-id="element-1336" data-mp="135ezi1r2kc8s" />
                  </div>

                  <Button type="submit" variant="primary" size="lg" isLoading={isSubmitting} leftIcon={<SendIcon className="w-4 h-4" data-id="element-1338" data-mp="2ssw6ngmkbim4" />} data-id="element-1337" data-mp="2o14p1vldwn84">
                    Send Message
                  </Button>
                </form>}
            </Card>
          </div>
        </div>

        {/* Map placeholder */}
        <div className="mt-12" data-id="element-1339" data-mp="205s8nvlw04ju">
          <Card padding="none" className="overflow-hidden" data-id="element-1340" data-mp="206l96eu95xtj">
            <div className="h-80 bg-gray-200 flex items-center justify-center" data-id="element-1341" data-mp="254mocook5czq">
              <div className="text-center" data-id="element-1342" data-mp="2a24ygieb9y9b">
                <MapPinIcon className="w-12 h-12 text-gray-400 mx-auto mb-2" data-id="element-1343" data-mp="2a1d5lfc3memq" />
                <p className="text-gray-500" data-id="element-1344" data-mp="2f2ixjaxxpxv7">Map integration would go here</p>
                <p className="text-sm text-gray-400" data-id="element-1345" data-mp="3liml5qs3wmir">Karachi, Pakistan</p>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>;
}